import { render, staticRenderFns } from "./TicketsResolutionsForm.vue?vue&type=template&id=56d38df9&scoped=true&"
import script from "./TicketsResolutionsForm.vue?vue&type=script&lang=js&"
export * from "./TicketsResolutionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d38df9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
